import { env } from "@/env";
import { datadogLogs } from "@datadog/browser-logs";

export const logger = (() => {
  const isSandboxOrLive =
    env.VITE_VOLUME_URL?.includes("api.volumepay.io") ||
    env.VITE_VOLUME_URL?.includes("api.sandbox.volumepay.io");

  const datadogLoggerKey = "MERCHANT_PORTAL";
  const datadogLoggerInstance =
    datadogLogs.getLogger(datadogLoggerKey) ??
    datadogLogs.createLogger(datadogLoggerKey);

  return {
    info: (message: string, messageContext?: object) => {
      if (isSandboxOrLive) {
        datadogLoggerInstance.info(message, messageContext);
      }
      console.log(message);
    },
    error: (message: string, messageContext?: object, error?: Error) => {
      if (isSandboxOrLive) {
        datadogLoggerInstance.error(message, messageContext, error);
      }
      console.error(message, messageContext, error);
    },
    setContextProperty: datadogLoggerInstance.setContextProperty,
  };
})();
